import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3157, { U3157ROLES } from './U3157';
import U3157WorkNatureImportModelList from './components/U3157WorkNatureImportModelList';
import U3157WorkNatureImportModelForm from './components/U3157WorkNatureImportModelForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3157Routes: RouteObject[] = [
  {
    path: 'U3157',
    element: <U2000RequireRole allowedRoles={[U3157ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3157 />,
        children: [
          { index: true, element: <U3157WorkNatureImportModelList /> },
          { path: ':id', element: <U3157WorkNatureImportModelForm /> },
        ],
      },
    ],
  },
];

export default U3157Routes;
